import { render } from "./translate_button.vue?vue&type=template&id=01405754"
import script from "./translate_button.vue?vue&type=script&lang=js"
export * from "./translate_button.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__